export default {
  getTenants(state) {
    return state.tenants;
  },
};
